import {keys} from "lodash";

export const capitalizeFirstLetter = (str: string): string => {
  if (str && str.length > 0) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  return str;
};

export const constructQueryParams = (queryParams: Partial<{ [k: string]: string }>): string => {
  return queryParams && Object.keys(queryParams).length > 0
    ? `?${Object.keys(queryParams)
        .map(key => `${key}=${queryParams[key]}`)
        .join('&')}`
    : '';
};

/**
 * This is meant for supporting csaas Metric Value widget's data format string. This is not going to be 
 * used elsewhere.
 * 
 * csaas Metric Value widget supports format strings such as "${v} ${m} ${bv} ${bm} ${t}" where it is 
 * supposed to replace the variables with the value. This is a convenience function for such action.
 */
export const metricFormatString =  (str : string, templateVars : { [index : string] : string }) : string => {
  let value : string;
  keys(templateVars).forEach(function (key : string) {

      value = ("" + templateVars[key]).replace(/\$/g, "$$$$");
      str = str.replace(new RegExp("\\$\\{" + key + "\\}", "gi"), value);
  });
  return str;
}